import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { restartCssAnimations } from "../utils/restart_css_animations"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.modal = Modal.getOrCreateInstance(this.element)
    // Safari: spinner inside this modal may have been injected while hidden;
    // restart CSS animations once the dialog is actually shown.
    this._onShown = () => restartCssAnimations(this.element)
    this.element.addEventListener("shown.bs.modal", this._onShown)
    this.modal.show()
    this._watchFormSubmit()
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.modal", this._onShown)
    const instance = Modal.getInstance(this.element)
    if (instance) {
      instance.hide()
      instance.dispose()
    }
    this._cleanupModalBodyState()
  }

  _cleanupModalBodyState() {
    if (!document.body.classList.contains("modal-open")) return

    document.querySelectorAll(".modal-backdrop").forEach(el => el.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")
  }

  hideBeforeRender(event) {
    if (this.isOpen()) {
      event.preventDefault()
      this.element.addEventListener('hidden.bs.modal', event.detail.resume)
      this.modal.hide()
    }
  }

  hideModal() {
    this.modal.hide()
  }

  isOpen() {
    return this.element.classList.contains("show")
  }

  closeWithKeyboard(e) {
    if (e.code == "Escape") {
      this.hideModal()
    }
  }

  closeBackground(e) {
    if (e && this.modalTarget.contains(e.target)) {
      return;
    }
    this.hideModal()
  }

  submit(e) {
    this.modalTarget.querySelector('form').requestSubmit()
  }

  submitEnd(e) {
    if (e.detail.success) {
      if (e.params.returnUrl) {
        Turbo.visit(e.params.returnUrl, { frame: "modal"})
      } else {
        this.hideModal()
      }
    }
  }

  back(event) {
    Turbo.visit(event.params.returnUrl, { frame: "modal"})
  }

  // Show spinner on submit buttons inside the modal
  _watchFormSubmit() {
    this.element.querySelectorAll('form').forEach(form => {
      form.addEventListener('submit', () => {
        form.querySelectorAll('[type=submit]').forEach(btn => {
          btn.disabled = true
          btn.dataset.originalText = btn.innerHTML
          btn.innerHTML = `<span class="spinner-border spinner-border-sm me-1" role="status"></span>${btn.dataset.originalText || ''}`
        })
      })

      form.addEventListener('turbo:submit-end', () => {
        form.querySelectorAll('[type=submit]').forEach(btn => {
          btn.disabled = false
          if (btn.dataset.originalText) {
            btn.innerHTML = btn.dataset.originalText
          }
        })
      })
    })
  }
}